import Axios from 'axios'
import {Message} from 'element-ui'
import store from '../store'
import router from '../router'

//开发环境的URL
//const baseURL = 'http://localhost:8888/api/private/v1/'
//测试环境
//const baseURL = 'http://test.abc.com/api/private/v1/'
//线上环境
//const baseURL = 'http://coc.sqifu.com/api/private/v1/'

// Axios.defaults.headers = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
const instance = Axios.create({
    baseURL: 'https://coc.sqifu.com/',
    // baseURL:'http://test.sqifu.com',
    timeout: 20000
})
// 添加请求拦截器
// instance.interceptors.request.use(function (config) {
//     // 在发送请求之前做些什么
//     if(store.state.token){
//         config.headers.Authorization = store.state.token
//     }
//     return config;
//   }, function (error) {
//     // 对请求错误做些什么
//     return Promise.reject(error);
//   });

// // 添加响应拦截器
// instance.interceptors.response.use(function (response) {
//     // 对响应数据做点什么
//     if(response.data.errmsg === '请先登录') {
//         router.replace({
//             name: 'login'
//         })
//     }
//     return response;
//   }, function (error) {
//     // 对响应错误做点什么
//     return Promise.reject(error);
//   });

export default function http(url, data, method, params){
    return instance({
        url,
        data,
        method,
        params
    }).then(res => {
        // console.log(res)
        return res
    }).catch(err => {
        Message.error(err)
        return Promise.reject(err)
    })
}


// WEBPACK FOOTER //
// ./src/http/index.js